'use client'
import { Settings2 as SettingIcon } from 'lucide-react'
import { Check } from 'lucide-react'
import { cn } from '@/services/utils/cn'
import { Button } from '@/components/ui/button'
import {
  Command,
  CommandGroup,
  CommandItem,
  CommandList,
} from '@/components/ui/command'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useState } from 'react'
import { SortBy, SortOrder } from '@/types/contest'
import { contestSorting } from '@/stores/contest-preference-store'
import { Portal } from '@radix-ui/react-popover'

interface PopoverSortbyProps {
  truncate?: boolean
  setSortBy: (value: SortBy) => void
  setSortOrder: (order: SortOrder) => void
}

export function PopoverSortby({
  truncate,
  setSortBy,
  setSortOrder,
}: PopoverSortbyProps) {
  const [open, setOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState<string | null>(
    contestSorting[0]?.id ?? null
  )

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-auto justify-between"
        >
          <div className="flex items-center gap-2">
            <SettingIcon />
            <p className="font-bold">เรียงตาม:</p>
            {/* {value
              ? sorting.find((sort) => sort.value === value)?.label
              : (sorting[0]?.value ?? '')} */}
            <span
              className={cn('md:w-full', truncate ? 'w-12 truncate' : 'w-full')}
            >
              {contestSorting.find((sort) => sort.id === selectedValue)?.label}
            </span>
          </div>
        </Button>
      </PopoverTrigger>
      <Portal>
        <PopoverContent className="pointer-events-auto relative z-[1000] w-[200px] p-0">
          <Command>
            <CommandList>
              <CommandGroup>
                {contestSorting.map((sort) => (
                  <CommandItem
                    key={sort.id}
                    value={sort.id}
                    onSelect={() => {
                      setSelectedValue(sort.id)
                      setSortBy(sort.value as SortBy)
                      setSortOrder(sort.order)
                      setOpen(false)
                    }}
                    className="cursor-pointer"
                  >
                    <div className="flex items-center gap-2">
                      <Check
                        className={cn(
                          'mr-auto',
                          sort.id === selectedValue
                            ? 'opacity-100'
                            : 'opacity-0'
                        )}
                      />
                      {sort.label}
                    </div>
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
